import { ReactNode } from 'react';
import { Root, createRoot } from 'react-dom/client';

const roots = new WeakMap<Element | DocumentFragment, Root>();

export const renderInContainer = (element: ReactNode, container: Element | DocumentFragment) => {
  const root = roots.get(container) ?? createRoot(container);
  roots.set(container, root);
  root.render(element);

  return root;
};
